import React, { useEffect, useState } from 'react';
import JavaScript from './JS';
import HTML from './HTML';
import CSS from './CSS';
import "./Theme.css";
import firebase from 'firebase'
import Login from '../Login/Login';
import PenSettings from '../PenSettings/PenSettings';
import NavBar2 from '../NavBar/NavBar3'
import { useSelector, useDispatch } from 'react-redux'
import { 
    setPenTitle, addCssCdn, removeCssCdn ,addJsCdn,removeJsCdn,
    setPenDescription,
    classTagHandler,
    setHeadStuff,
    loadPen,
    setDefaultPen
} from '../../redux/actions/penActions'
import { setForkBtnTxt, setPopUp, setSaveBtnTxt } from '../../redux/actions/uiActions';
import Loader from '../Loader';

require('codemirror/lib/codemirror.css');


const InitEditor = (props) => {
    const { is_loading } = useSelector(state => state.authReducer)
    return is_loading ? <Loader /> : <CodeEditor props={props} />
}


function CodeEditor({props}){
    const db = (e) => firebase.firestore().collection(e)
    const { id, access_id } = props.match.params
    const { is_logged_in, user_data } = useSelector(state => state.authReducer)
    const { show_popup } = useSelector(state => state.uiReducer)
    const penReducer = useSelector(state => state.penReducer)
    const { 
        pen_html, pen_css, pen_js, pen_title, 
        cssSettings,jsSettings, pen_description,
        pen_user_id,htmlSettings,pen_id
    } = penReducer
    const [showEditor, setEditor] = useState(false)
    const [initialText, setText] = useState("Please wait...")
useEffect(() => {
    
    if(inIframe()) {
        if(!access_id) {
            alert("Invalid Authentication token")
            setText("Unauthorized")
            return
        }
        console.log("ACCESS ID ", access_id )
        firebase.firestore().collection("users").doc(access_id)
        .get()
        .then(snap => {
            const data = snap.data()
            if(!snap.exists)
            {
                // alert("Invalid Authentication token")
                setText("Invalid Authentication token")
                return
            }
            if(!data.api_access)
            {
                
                //alert("You are not allowed to use this api")
                setText("You are not allowed to use this api")
                return
            } else {
                setEditor(true) 
            }
        })
    }
    else {
        setText("Widget is not available in browser")
    }
    if(!id && !is_logged_in) {
        setState({
            ...state,
            pen_loading : false
        })
        return
    }
    db("pens").doc(id).get()
        .then(snap => {
            if(snap.exists)
            dispatch(loadPen(snap.data()))
            setState({
                ...state,
                pen_loading : false
            })
        })
    return () => {
        setState({
            ...state,
            pen_loading : true
        })
        dispatch(setDefaultPen())
    }
},[])

    const dispatch = useDispatch()
    const [state, setState] = useState({
        showSettings: false,
        showPopUp: false,
        showSignUp: false,
        pen_loading : true,
        theme: "twilight",
        behaviorSettings: {
            tabSize: 0,
            autoSave: false,
            autoUpdate: true,
        },
        pageSelection: 'html'
    })

    /////// SERVER INTERACTION //////////////
const savePen = () => {
    dispatch(setSaveBtnTxt("Saving...")) 

if (!is_logged_in) {
    dispatch(setPopUp(true))
    dispatch(setSaveBtnTxt("Save")) 
    return
}

if(pen_html.length + pen_css.length + pen_js.length < 40){
    alert("Please write at least few lines of code")
    dispatch(setSaveBtnTxt("Save")) 
    return
}

if ( pen_user_id === user_data.uid ) {
    db("pens").doc(pen_id)
    .set(penReducer)
    .then(_ =>  dispatch(setSaveBtnTxt("Save")) )
    } else {
    db("pens").add({
        ...penReducer,
        saved_at : firebase.firestore.FieldValue.serverTimestamp(),
        pen_user_name : user_data.name,
        user_photo_url : user_data.photo_url
    })
    .then(penRef => {
        db("users").doc(user_data.uid)
            .set({
                pens : firebase.firestore.FieldValue.arrayUnion(penRef.id)
            },{merge : true})
            penRef.set({
            pen_id : penRef.id,
            pen_user_id : user_data.uid,
            pen_type : "created"
        }, { merge : true})
    })
    .then(_ => {
        dispatch(setSaveBtnTxt("Save")) 
        alert("Pen saved")
    })
}
}

function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return false;
    }
}

// Behavior Page Handlers
const autoSaveHandler = (value)=> {
    setState({
        ...state,
        behaviorSettings: Object.assign({}, state.behaviorSettings, { autoSave: value })
    })
}
const autoUpdateHandler =(value) => {
    setState({
        ...state,
        behaviorSettings: Object.assign({}, state.behaviorSettings, { autoUpdate: value })
    })

}
const tabSizeHandler = (value) => {
    setState({
        ...state,
        behaviorSettings: Object.assign({}, state.behaviorSettings, { tabSize: value })
    })
}

// settings page selection
const settingsPageSelectionHandler = (pageName) => {
    setState({
        ...state,
        pageSelection: pageName,
        showSettings: true
    })
    // html, css, js, behavior, details
}

    //// SETTINGS POPUP CONTROLLERS ////////
const settingsPopUpHandler = (value) => {
    setState({
        ...state,
        showSettings: value
    })
}

//////////// ACCOUNT VALIDATION //////////////
const closePopUp = (bool = false) => {
    dispatch(setPopUp(false))
    if (bool) {
        setState({
            ...state,
            showPopUp: false,
            isLoggedIn: true,
            showSignUp: false
        })
        savePen()
    }
    else {
        setState({
            ...state,
            showPopUp: false, showSignUp: false })
    }
}
const popUpSwitch = () => {
    dispatch(setPopUp(false))
    setState({ 
        ...state,
        showSignUp: !state.showSignUp })
}


const fork = () => {
    dispatch(setForkBtnTxt("Saving..."))

    if (!is_logged_in) {
        setState({
            ...state,
            showPopUp: true
        })
        dispatch(setPopUp(true))
        dispatch(setSaveBtnTxt("Save")) 
        return
    }
const penObj = {
    ...penReducer,
    pen_type : "forked",
    forks : [],
    loves : [],
    views : 0,
    fork_count : 0,
    love_count : 0,
    pen_user_id : user_data.uid,
}
    db("pens").add(penObj).then(docRef => {
        db("users").doc(user_data.uid)
                .set({
                    pens : firebase.firestore.FieldValue.arrayUnion(docRef.id)
                },{merge : true})
        db("pens").doc(docRef.id)

        .set({
            pen_id : docRef.id,
            pen_user_id : user_data.uid,
            forked_from : pen_user_id,
        },{merge : true})
        .then(_ => {
            db("pens").doc(pen_id)
            .set({
                fork_count :penReducer.fork_count + 1,
                forks : firebase.firestore.FieldValue.arrayUnion(user_data.uid)
            }, {merge : true})
        .then(_ => {
            dispatch(loadPen({
                ...penReducer,
                pen_type : "forked",
                forks : [],
                loves : [],
                views : 0,
                fork_count : 0,
                love_count : 0,
                pen_user_id : user_data.uid,
                pen_id : docRef.id,
                forked_from : pen_user_id
            }))
            window.location.hash = `/editor/${docRef.id}`
                dispatch(setForkBtnTxt("Save"))     
            })
        })
    })
}

const settingsMenu = (
    <div className="pen-settings-popup-container">
        <PenSettings
            settingsPopUpHandler={settingsPopUpHandler}
            htmlSettings={htmlSettings}
            classTagHandler={(value) => dispatch(classTagHandler(value))}
            headStuffHandler={(value) => dispatch(setHeadStuff(value))}

            cssSettings={cssSettings}
            cssCdnSelectHandler={data => dispatch(addCssCdn(data.latest))}
            removeCssCdn={value => dispatch(removeCssCdn(value))}

            jsSettings={jsSettings}
            jsCdnSelectHandler={data => dispatch(addJsCdn(data.latest))}
            removeJsCdn={value => dispatch(removeJsCdn(value))}

            behaviorSettings={state.behaviorSettings}
            autoSaveHandler={autoSaveHandler}
            autoUpdateHandler={autoUpdateHandler}
            tabSizeHandler={tabSizeHandler}

            pageSelection={state.pageSelection}
            pageHandler={settingsPageSelectionHandler}

            savePen={savePen}

            updateName={(e) => dispatch(setPenTitle(e.target.value))}
            name={pen_title}
            updateDescription={e => dispatch(setPenDescription(e.target.value))}
            description={pen_description}
        />
        <div onClick={() => settingsPopUpHandler(false)} className="pen-settings-popup-overlay"></div>
    </div>
)


const popUp = (
    <div className="signup-popup">
        <div className="signup-popup-container-postition">
            <div className="signup-popup-form-container">
                    <Login isPopUp={true} closePopUp={closePopUp} switch={popUpSwitch} />
            </div>
        </div>
        <div onClick={() => closePopUp(false)} className="signup-popup-overlay"></div>
    </div>
)

let stylesheetString = cssSettings.cssCdnList.filter(element => element).reduce((string, element) => {
    return string + `<link rel='stylesheet' href='${element}'>`
}, '')

let jsLibraryString = jsSettings.jsCdnList.reduce((string, element) => {
    return string + `<script type='text/javascript' src='${element}'></script>`
}, '')
let srcdoc = `
<html class='${htmlSettings.htmlClassTag || ''}'>
    <head>
        ${stylesheetString}
        ${htmlSettings.head || ''}  
        <script
            src="https://code.jquery.com/jquery-3.6.0.min.js"
            integrity="sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4="
            crossorigin="anonymous"></script>          
    </head>
    <body>${pen_html}</body>
    <style>${pen_css}</style>
    ${jsLibraryString}
    
    <script>${pen_js}</script>
</html>`;

if(!showEditor || !inIframe())
return  <div>
            <h1 className="text-4xl text-mono">{initialText}</h1>
        </div>
else return(
    <div>
        <NavBar2
            savePen={savePen}
            penUserId={pen_user_id}
            isUser={ is_logged_in ? user_data.uid === pen_user_id : null}
            history={props.history}
            userName={is_logged_in ? user_data.name : ''}
            updateName={(e) => dispatch(setPenTitle(e.target.value))}
            penName={pen_title}
            isLoggedIn={is_logged_in} 
            showSettings={state.showSettings} 
            settingsPopUpHandler={settingsPopUpHandler} 
            fork={fork}
            penLoading={state.pen_loading}
            accessId={access_id}
        />
        <div className="codeEditor">
            {show_popup && popUp}
            {state.showSettings ? settingsMenu : null}
            <div className="editorHead mt-1">
                <section className="editorSection w-1/3">
                    <div>
                        <button
                            onClick={() => settingsPageSelectionHandler('html')}
                        ><img className="settingsImg" src="http://www.clker.com/cliparts/5/t/n/f/d/T/white-gear-hi.png" alt="settings" /></button>
                        <h3>HTML</h3>
                    </div>
                    {/* <button><img className="settingsImg" src="http://i66.tinypic.com/2gufexh.jpg" alt="down arrow" /></button> */}
                </section>
                <section className="editorSection w-1/3">
                    <div>
                        <button
                            onClick={() => settingsPageSelectionHandler('css')}
                        ><img className="settingsImg" src="http://www.clker.com/cliparts/5/t/n/f/d/T/white-gear-hi.png" alt="settings" /></button>
                        <h3>CSS</h3>
                    </div>
                </section>
                <section className="editorSection w-1/3">
                    <div>
                        <button
                            onClick={() => settingsPageSelectionHandler('js')}
                        ><img className="settingsImg" src="http://www.clker.com/cliparts/5/t/n/f/d/T/white-gear-hi.png" alt="settings" /></button>
                        <h3>JS</h3>
                    </div>
                    {/* <button><img className="settingsImg" src="http://i66.tinypic.com/2gufexh.jpg" alt="down arrow" /></button> */}
                </section>
            </div>
            {!state.pen_loading ? <div className="editor">
                <HTML theme={state.theme} />
                <CSS theme={state.theme} />
                <JavaScript js={pen_js} theme={state.theme} />
            </div>
            :
            <div className="editor bg-gray-700" style={{
                paddingLeft : 7,
                
            }}>
                <div className="w-1/3 bg-black h-72 border-8 border-gray-700" />
                <div className="w-1/3 bg-black h-72 border-8 border-gray-700" />
                <div className="w-1/3 bg-black h-72 border-8 border-gray-700" />
            </div>    
            } 
            <div className="verticalResize"></div>
            <iframe className="penFrame" srcDoc={srcdoc} frameBorder="0" title="showPen"></iframe>
            {/* <div className="penFooter">
                {
                state.visitingUserId === state.penUserId ? (
                    <button onClick={() => savePen()}>Save</button>
                ) : (
                        null
                    )}
                {state.visitingUserId === state.penUserId ? (
                    <button onClick={deletePen} className="delete">Delete</button>
                ) : (
                        null
                    )}
            </div> */}
        </div>
        </div >
    )
}


export default InitEditor;


// WEBPACK FOOTER //
// ./src/components/CodeEditorAPI/CodeEditor.js